export default {
    cookie: {
        name: 'occ'
    },
    keys: {
        id: 'id'
    },
    operators: {
        in: 'In',
        lowerThan: 'Lt',
        greaterThan: 'Gt',
    },
    inputTypes: {
        checkboxes: 'checkboxes',
        dropdown: 'dropdown',
    },
    queryParams: {
        page: 'page',
        text: 'text',
    },
    cookies: {
        listBlockView: 'listBlockView',
    },
    magicStrings: {
        queryCount: '{{queryCount}}',
        totalCount: '{{totalCount}}',
    },
    breakpoints: {
        mobile: 480,
        tablet: 768,
        desktop: 1024,
        widescreen: 1216,
        fullHD: 1408,
    }
}
